import React from 'react';

const RemoveIcon = function RemoveIcon() {
  return (
    <svg
      width="41px"
      height="41px"
      viewBox="0 0 41 41"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Client-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="People-Edit" transform="translate(-320.000000, -1328.000000)">
          <g id="Group-10-Copy-18" transform="translate(320.000000, 1329.000000)">
            <circle id="Oval" fill="#001760" cx="20.645159" cy="20" r="20" />
            <text id="+" transform="translate(19.176062, 19.530903) rotate(-45.000000) translate(-19.176062, -19.530903) " fontFamily="RobotoSlab-Regular, Roboto Slab" fontSize="30" fontWeight="normal" fill="#FFFFFF">
              <tspan x="11.5570149" y="31.0309034">+</tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default RemoveIcon;
